<template>
    <van-popup v-if="memberPopupShow " :value="memberPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="member_tpl_wrap" ref="recordDialog">
            <div class="project_record_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>

            <div class="member_tpl_bottom">
                <van-form colon ref="formData" scroll-to-error>
                    <ul>
                        <li>
                            <van-field :rules="formRules.member_uid" @click="handleClickHeadUser" input-align="right" label="项目成员" is-link readonly placeholder="请选择" required  v-model="formData.member_uid_text"></van-field>
                        </li>
                        <li>
                            <van-field :rules="formRules.member_role"  input-align="right" label="角色名称"  placeholder="请输入" required v-model="formData.member_role"></van-field>
                        </li>
                        <li style="padding: 12px 16px;box-sizing: border-box">
                            <div class="permission_range_wrap">
                                <div class="permission_range_top">
                                    <el-checkbox  v-model="checkAll" @change="handleCheckAllChange"><h5>全部权限</h5></el-checkbox>
                                </div>
                                <div class="permission_range_bottom">
                                    <el-checkbox-group v-model="formData.permission_range" @change="handleCheckedChange">
                                        <div class="look_item">
                                            <h5>项目详情-业务相关</h5>
                                            <el-switch  :value="formData.permission_range.indexOf('business_related_detail') > -1" @change="handleSwitchChange('business_related_detail')" active-color="#2990FF"></el-switch>
                                        </div>
                                        <template v-if="formData.permission_range.indexOf('business_related_detail') > -1">
                                            <div class="checkbox_item"><el-checkbox  label="business_manage" key="business_manage">管理权限（可新增或关联商机、订单、工单）</el-checkbox></div>
                                        </template>

                                        <div class="look_item">
                                            <h5>项目详情-财务相关</h5>
                                            <el-switch  :value="formData.permission_range.indexOf('financial_related_detail') > -1" @change="handleSwitchChange('financial_related_detail')" active-color="#2990FF"></el-switch>
                                        </div>
                                        <template v-if="formData.permission_range.indexOf('financial_related_detail') > -1">
                                            <div class="checkbox_item"><el-checkbox  label="financial_payment" key="financial_payment">可查看项目回款/开票数据</el-checkbox></div>
                                            <div class="checkbox_item"><el-checkbox  label="financial_profit" key="financial_profit">可查看项目实际利润/项目成本数据</el-checkbox></div>
                                            <div class="checkbox_item"><el-checkbox  label="financial_cost" key="financial_cost">可新增/编辑/删除项目成本</el-checkbox></div>
                                        </template>

                                        <div class="look_item">
                                            <h5>项目详情-库存相关</h5>
                                            <el-switch  :value="formData.permission_range.indexOf('inventory_related_detail') > -1" @change="handleSwitchChange('inventory_related_detail')" active-color="#2990FF"></el-switch>
                                        </div>
                                        <template v-if="formData.permission_range.indexOf('inventory_related_detail') > -1">
                                            <div class="checkbox_item"><el-checkbox  label="inventory_total_cost" key="inventory_total_cost">可查看产品成本总价</el-checkbox></div>
                                        </template>

                                        <div class="look_item">
                                            <h5>项目详情-项目成员</h5>
                                            <el-switch  :value="formData.permission_range.indexOf('member_related_detail') > -1" @change="handleSwitchChange('member_related_detail')" active-color="#2990FF"></el-switch>
                                        </div>
                                        <template v-if="formData.permission_range.indexOf('member_related_detail') > -1">
                                            <div class="checkbox_item"><el-checkbox  label="member_operate" key="member_operate">添加成员/操作权限</el-checkbox></div>
                                        </template>

                                        <div class="look_item">
                                            <h5>项目详情-项目资料</h5>
                                            <el-switch  :value="formData.permission_range.indexOf('project_file_detail') > -1" @change="handleSwitchChange('project_file_detail')" active-color="#2990FF"></el-switch>
                                        </div>
                                        <template v-if="formData.permission_range.indexOf('project_file_detail') > -1">
                                            <div class="checkbox_item"><el-checkbox  label="project_file_operate" key="project_file_operate">上传/操作权限</el-checkbox></div>
                                        </template>

                                    </el-checkbox-group>
                                </div>

                            </div>
                        </li>
                    </ul>
                </van-form>
            </div>

            <div class="member_tpl_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
            </div>

            <!-- 人员选择 -->
            <UserSearchSelect :userSelectVisible.sync="userSelectVisible"  :userSelectTitle="'选择人员'" :selectType="'multiple'" @selectUserData="handleSelectUserData" :selectedUser="formData.member_uid" v-if="userSelectVisible"/>
        </div>
    </van-popup>
</template>
<script>
import { ProjectManageMemberAdd,  ProjectManageMemberEdit} from "@/api/index.js"
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "member_tpl",
    components: {
        UserSearchSelect
    },
    props: {
        memberPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        projectMemberId: {
            type: Number,
            default: 0
        },
        projectMemberInfo: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            btnDisabled:false,
            formData: {
                member_uid:[],
                member_uid_text:'',
                member_role:'',
                permission_range:[]
            },
            formRules: {
                member_uid: [{required: true, message: "请选择项目成员", trigger: 'onChange'}],
                member_role: [{required: true, message: "请输入角色名称", trigger: 'onBlur'}],
            },
            userList:[],
            checkAll:false,//是否全选
            allOptions:[
                    'business_related_detail',
                    'business_manage',
                    'financial_related_detail',
                    'financial_payment',
                    'financial_profit',
                    'financial_cost',
                    'inventory_related_detail',
                    'inventory_total_cost',
                    'member_related_detail',
                    'member_operate',
                    'project_file_detail',
                    'project_file_operate'
                ],
            userSelectVisible:false,

        }
    },
    created() {

        if(this.projectMemberInfo){
            this.formData.member_uid = this.projectMemberInfo.members.map(item=>{
                return item.member_uid
            })
            this.formData.member_uid_text = this.projectMemberInfo.members.map(item=>{
                return item.member_user.name
            }).join(',')
            this.formData.permission_range = this.projectMemberInfo.permission_range
            this.formData.member_role = this.projectMemberInfo.member_role

            if(this.allOptions.length == this.formData.permission_range.length){
                this.checkAll = true
            }
        }
    },
    methods: {
        // 全选
        handleCheckAllChange(val){
            this.formData.permission_range = val ? this.allOptions : [];
        },
        // 选择
        handleCheckedChange(value){
            let length = value.length;
            if(length == this.allOptions.length){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        handleSwitchChange(value){
          let index = this.formData.permission_range.indexOf(value)
            if(index > -1){
                this.formData.permission_range.splice(index, 1)
            }else{
                this.formData.permission_range.push(value)
            }

            if(this.formData.permission_range.length == this.allOptions.length){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        // 选择项目负责人
        handleClickHeadUser(){
            this.userSelectVisible = true
        },
        // 选择人员回调
        handleSelectUserData(data){

            this.$set(this.formData,'member_uid',data.map(item=>{return item.uid}))
            this.$set(this.formData,'member_uid_text',data.map(item=>{return item.name}).join(','))

        },
        handleClickClose() {
            this.$emit("update:memberPopupShow", false)
        },
        handleClickConfirm() {
            this.$refs.formData.validate().then(() => {
                    let postData = JSON.parse(JSON.stringify(this.formData))
                    postData.project_manage_id = this.projectId
                    this.btnDisabled = true
                    if(this.projectMemberId){
                        postData.id = this.projectMemberId
                        ProjectManageMemberEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$toast({
                                    message:'编辑成功',
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        this.$emit('success')
                                        this.$emit('update:memberPopupShow', false)
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    }else{
                        ProjectManageMemberAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$toast({
                                    message:'新增成功',
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        this.$emit('success')
                                        this.$emit('update:memberPopupShow', false)
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    }

            })
        },


    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";

</style>
